export default "__VITE_ASSET__BPvqmxrD__"